module.exports = __webpack_public_path__ + "images/renters.20130a3650ff9066449ddd5c406a55ec.svg";